import styled from "styled-components";
const EmptyTd = styled.td`
  background-color: #fafafa;
  border: 0px !important;
`;

export default EmptyTd;
